import { TextFieldProps } from '@mui/material'
import { FieldErrors, UseFormRegister } from 'react-hook-form'

import TextField from '@/Components/Common/Inputs/TextField'

const EmailField: React.FC<
  TextFieldProps & {
    register: UseFormRegister<any>
    errors: FieldErrors
  }
> = ({ register, errors, ...props }) => {
  return (
    <TextField
      label="Email"
      {...register('email', {
        required: 'Email is required',
        validate: (value: string) => {
          if (value && !/^[^@\s]+@[^@\s]+$/.test(value)) {
            return 'Please enter a valid email address'
          }
          return true
        }
      })}
      required
      type="email"
      error={!!errors.email}
      helperText={errors.email?.message as string}
      {...props}
    />
  )
}

export default EmailField
